// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-field__control{text-indent:70px}.van-field__label{text-align:left;font-weight:600}.ad-request{margin-bottom:20px;border:1px solid #eaeaea}.ad-request .van-field__control{text-indent:10px}.ad-request .van-cell:first-of-type{padding-top:0}.van-uploader__upload{background-color:#ccc}.van-uploader{position:static}", ""]);
// Exports
module.exports = exports;
